module.exports = __webpack_public_path__ + "img/0b370c5.jpg";